export type DepartmentFormMode = 'same-tab' | 'new-tab' | 'drawer' | 'modal';

export const DEPARTMENT_FORM_MODE_OPTIONS: { value: DepartmentFormMode; label: string }[] = [
  { value: 'same-tab', label: 'Na tejto karte' },
  { value: 'new-tab', label: 'Na novej karte' },
  { value: 'drawer', label: 'V bočnom paneli' },
  { value: 'modal', label: 'V modálnom okne' },
];

/** Checks persisted values before using them as presentation modes. */
export function isDepartmentFormMode(value: unknown): value is DepartmentFormMode {
  return DEPARTMENT_FORM_MODE_OPTIONS.some((option) => option.value === value);
}
